<template>
  <WorkWarningDialog
    ref="warningDialog"
    :message="message"
  >
    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <w-btn
        v-if="showClose"
        :outlined="showResolve"
        @click="close"
      >
        {{ closeLabel }}
      </w-btn>
      <w-btn
        v-if="showReject"
        :outlined="showResolve"
        @click="triggerReject"
      >
        {{ rejectLabel }}
      </w-btn>
      <w-btn
        v-if="showResolve"
        @click="triggerResolve"
      >
        {{ resolveLabel }}
      </w-btn>
    </template>
  </WorkWarningDialog>
</template>

<script>
import WorkWarningDialog from '@/components/base_components/dialog/icon-dialogs/WorkWarningDialog';
import i18n from '@/language/i18n';

const DEFAULT_CLOSE_LABEL = i18n.t('Dialogs.BasicDialog.abort');
const DEFAULT_REJECT_LABEL = i18n.t('Dialogs.BeforeLeaveDialog.abort');
const DEFAULT_RESOLVE_LABEL = i18n.t('Dialogs.ConfirmationDialog.confirm');

export default {
  name: "WorkGlobalWarningDialog",
  components: { WorkWarningDialog },
  data() {
    return {
      message: "",
      closeLabel: DEFAULT_CLOSE_LABEL,
      resolveLabel: DEFAULT_RESOLVE_LABEL,
      rejectLabel: DEFAULT_REJECT_LABEL,
      showResolve: true,
      showReject: false,
      showClose: true,
    }
  },
  methods: {
    async open({ message, closeLabel = DEFAULT_CLOSE_LABEL, resolveLabel = DEFAULT_RESOLVE_LABEL, rejectLabel = DEFAULT_REJECT_LABEL, showResolve = true, showClose = true, showReject = false }) {
      this.message = message;
      this.closeLabel = closeLabel;
      this.rejectLabel = rejectLabel;
      this.resolveLabel = resolveLabel;
      this.showReject = showReject;
      this.showResolve = showResolve;
      this.showClose = showClose;

      await this.$refs.warningDialog.open();
    }
  }
}
</script>
